import { motion } from "framer-motion";
import { Star } from "lucide-react";
const testimonials = [
  { name: "Sarah Jenkins", role: "Frequent Traveler", image: "https://images.pexels.com/photos/6572210/pexels-photo-6572210.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", quote: "FlyInVisa made my UK visa application incredibly smooth. Got approved in just 2 days.", rating: 5 },
  { name: "Ahmed Al-Fayed", role: "Business Executive", image: "https://images.pexels.com/photos/14589344/pexels-photo-14589344.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", quote: "As someone who travels frequently for business, having a reliable visa service is crucial. Highly recommended.", rating: 5 },
  { name: "Emily Chen", role: "Digital Nomad", image: "https://images.unsplash.com/photo-1689600944138-da3b150d9cb8?w=400", quote: "The platform is intuitive, and the real-time tracking feature is a game changer. Best visa service I've used.", rating: 5 },
];
export default function Testimonials() {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="py-20 md:py-28 px-6 bg-slate-50">
      <div className="max-w-6xl mx-auto">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-center mb-16">
          <span className="text-xs tracking-widest uppercase font-semibold text-blue-600 mb-3 block">Testimonials</span>
          <h2 className="heading-font text-3xl md:text-4xl font-bold text-slate-900">What Our Clients Say</h2>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {testimonials.map((t, i) => (
            <motion.div key={t.name} initial={{ opacity: 0, y: 15 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ delay: i * 0.1 }} className="card-elevated p-6 flex flex-col" data-testid={`testimonial-${i+1}`}>
              <div className="flex gap-0.5 mb-4">{Array.from({ length: t.rating }).map((_, j) => <Star key={j} className="w-4 h-4 fill-amber-400 text-amber-400" />)}</div>
              <p className="text-sm text-slate-600 leading-relaxed flex-1 mb-5">"{t.quote}"</p>
              <div className="flex items-center gap-3 pt-4 border-t border-slate-100">
                <img src={t.image} alt={t.name} className="w-9 h-9 rounded-full object-cover" loading="lazy" />
                <div><p className="text-sm font-semibold text-slate-900">{t.name}</p><p className="text-xs text-slate-400">{t.role}</p></div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
